<template>
    <div class="page-contact">
        <div class="jumbo-wrapper contact">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">CONTACT</p>
                    <h2 class="t42">
                        LET US KNOW
                        <br/>
                        HOW WE CAN HELP!
                    </h2>
                    <p class="t20">Our business is your success!</p>
                </div>
            </div>
        </div>

        <div class="box-content contact">
            <div class="row">
                <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                    <div class="icon-box">
                        <div class="phone-icon">
                            <img class="" src="images/Contact-Page/phoneicon.png" alt="">
                        </div>
                    </div>
                    <h2>CONTACT US</h2>
                    <p>1-800-288-6447</p>
                    <p><a href="mailto:bricks@fundraisersltd.com">bricks@bricksrus.com</a></p>
                    <p class="button">
                        <router-link to="/open-info-request-website" tag="button" class="learn-more-button gray">
                            <span>REQUEST MORE INFO</span>
                        </router-link>
                    </p>
                    <p class="button">
                        <router-link to="/open-callback-website" tag="button" class="learn-more-button gray">
                            <span>REQUEST A CALLBACK</span>
                        </router-link>
                    </p>
                </div>
                <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                    <div class="icon-box">
                        <div class="address-icon">
                            <img class="" src="images/Contact-Page/addressicon.png" alt="">
                        </div>
                    </div>
                    <h2>MAILING ADDRESS</h2>
                    <p>Fund Raisers, Ltd.</p>
                    <p>2700 E. Lanark St</p>
					<p>Suite 120</p>
                    <p>Boise, ID 83642</p>
                </div>
                <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                    <div class="icon-box">
                        <div class="clock-icon">
                            <img class="" src="images/Contact-Page/hoursicon.png" alt="">
                        </div>
                    </div>
                    <h2>OFFICE HOURS</h2>
                    <p>Monday - Friday</p>
                    <p>9am - 6pm CST</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'contact',
        metaInfo: {
            title: 'Contact',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Contact Fund Raisers, Ltd. 615 E. 43rd St, Boise, ID 83714, phone: 1-800-288-6447, e-mail: bricks@fundraisersltd.com'
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// Contact.vue?732a9f5a